import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4.99976 18.9928L18.9997 5.00004",
  stroke: "currentColor",
  "stroke-width": "2"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19 19.0001L5.00004 5.00731",
  stroke: "currentColor",
  "stroke-width": "2"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }